module.exports = __webpack_public_path__ + "static/media/login.dca4ee67.svg";